













import { Vue, Component } from 'vue-property-decorator'
import navbar from '@/components/navs/navbar.vue'

@Component({
  components: {
    navbar
  }
})

export default class App extends Vue {}
